import {FC, useEffect, useRef, useState} from 'react'
import {ShowSnackBar} from '../../../../../../util/functions'
import {KTCard} from '../../../../../../../../_metronic/helpers'
import {Button, ButtonWrapper} from '../../../../../../components/UI/Button'
import {CREATION_CLEANING_ACTIVITIES_SERVICES} from '../../../../services/creation-cleaning-activities.service'
import {SelectWrapper} from '../../../../../../components/UI/Form/Input'
import {FormProvider, useForm} from 'react-hook-form'
import {useCompanies} from '../../../../hooks/central/useCompanies'
import {useClients} from '../../../../hooks/central/useClients'
import {useSites} from '../../../../hooks/central/useSites'
import {useCampaments} from '../../../../hooks/central/useCampaments'
import {yupResolver} from '@hookform/resolvers/yup'
import {CleaningActivitiesDto} from '../../../../model/creationCleaningActivities.model'
import {downloadCleaningActivitiesSchema} from '../../../../schema/downloadMasiveCleaningActivities'

interface Props {
  serviceTemplate?: () => void
  handleSendService?: (data: any, bulkLoadId: string) => Promise<any>
  textData?: string
  textData1?: string
  showModalList?: boolean
  title?: string
  fileNameDownload?: string | null
}
export const MasiveCleaningActivities: FC<Props> = ({
  serviceTemplate = () => {},
  handleSendService = async () => {},
  textData1 = '',
  textData = '',
  showModalList = false,
  title = '',
  fileNameDownload,
}) => {
  const [loadingDownload, setLoadingDownload] = useState(false)

  const {getCompanies, companies, clearCompanies} = useCompanies()
  const {getClients, clients, clearClients} = useClients()
  const {getSites, sites, clearSites} = useSites()
  const {getCampaments, campaments, clearCampaments} = useCampaments()

  const methods = useForm<CleaningActivitiesDto>({
    resolver: yupResolver(downloadCleaningActivitiesSchema),
    defaultValues: {
      CompaniaId: '',
      ClienteId: '',
      SiteId: '',
      CampamentoId: '',
    },
  })
  const {setValue, handleSubmit, setError, watch, reset} = methods

  useEffect(() => {
    getCompanies({isCombo: true}, 1)
  }, [])

  useEffect(() => {
    if (companies.length === 1) {
      setValue('CompaniaId', companies[0].value)
      setError('CompaniaId', {})
      getClients({isCombo: true, companiaId: companies[0].value}, 1)
    }
  }, [companies])

  useEffect(() => {
    if (clients.length === 1) {
      setValue('ClienteId', clients[0].value)
      setError('ClienteId', {})
      getSites({isCombo: true, clienteId: clients[0].value}, 1)
    }
  }, [clients])

  useEffect(() => {
    if (sites.length === 1) {
      setValue('SiteId', sites[0].value)
      setError('SiteId', {})
      getCampaments({isCombo: true, siteId: sites[0].value}, 1)
    }
  }, [sites])

  useEffect(() => {
    if (campaments.length === 1) {
      setValue('CampamentoId', campaments[0].value)
      setError('CampamentoId', {})
    }
  }, [campaments])

  const handleCompanyChange = (val: any) => {
    let value = val ? val.value : ''
    setValue('CompaniaId', value)
    setValue('ClienteId', '')
    setValue('SiteId', '')
    clearSites()
    setValue('CampamentoId', '')
    clearCampaments()
    setError('CompaniaId', {})
    clearClients()
    getClients({isCombo: true, companiaId: value}, 1)
  }

  const handleClientChange = (val: any) => {
    let value = val ? val.value : ''
    setValue('ClienteId', value)
    setValue('SiteId', '')
    setValue('CampamentoId', '')
    clearSites()
    clearCampaments()
    setError('ClienteId', {})
    getSites({isCombo: true, clienteId: value}, 1)
  }

  const handleSiteChange = (val: any) => {
    let value = val ? val.value : ''
    setValue('SiteId', value)
    setValue('CampamentoId', '')
    setError('SiteId', {})
    clearCampaments()
    getCampaments({isCombo: true, siteId: value}, 1)
  }

  const handleDownload = async (data: CleaningActivitiesDto) => {
    try {
      setLoadingDownload(true)
      const response = (await CREATION_CLEANING_ACTIVITIES_SERVICES.downloadMasiveQR({
        ...data,
        pageNumber: 1,
        size: 10,
      })) as any
      const blob = new Blob([response.data], {
        type: 'application/pdf',
      })
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = fileNameDownload ? `${fileNameDownload}.pdf` : `Lista_QRs.pdf` // Ajusta el nombre del archivo según tus necesidades
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      setLoadingDownload(false)
    } catch (error) {
      ShowSnackBar('Hubo un error', 'error')
    }
  }

  return (
    <KTCard shadow className='m-5'>
      <div className='p-6'>
        <FormProvider {...methods}>
          <form className='m-2'>
            <div className='d-flex row'>
              <div className='mb-2 col-sm-12 col-md-4 col-xl-3'>
                <SelectWrapper
                  labelText='Compañia'
                  name='CompaniaId'
                  data={companies}
                  onChangeValue={handleCompanyChange}
                  required
                />
              </div>
              <div className='mb-2 col-sm-12 col-md-4 col-xl-3'>
                <SelectWrapper
                  labelText='Cliente'
                  name='ClienteId'
                  data={clients}
                  onChangeValue={handleClientChange}
                  required
                />
              </div>
              <div className='mb-2 col-sm-12 col-md-4 col-xl-3'>
                <SelectWrapper
                  labelText='Site'
                  name='SiteId'
                  data={sites}
                  onChangeValue={handleSiteChange}
                  required
                />
              </div>
              <div className='mb-2 col-sm-12 col-md-4 col-xl-3'>
                <SelectWrapper
                  labelText='Campamento'
                  name='CampamentoId'
                  data={campaments}
                  required
                />
              </div>
            </div>
            {/* <pre>{JSON.stringify(watch(), null, 2)}</pre> */}
            <ButtonWrapper className={'sdx-white-bg'}>
              <Button
                label='Descargar QR'
                onClick={handleSubmit(handleDownload)}
                loading={loadingDownload}
                disabled={loadingDownload}
              />
              <Button
                label='Limpiar'
                onClick={() => {
                  reset()
                }}
              />
            </ButtonWrapper>
          </form>
        </FormProvider>
      </div>
    </KTCard>
  )
}
